/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { t } from "i18n";
import { get } from "lodash";
import TextField from "components/text-field/text-field";
import NumberField from "components/number-field/number-field";
import { FcmConfig, Integrations } from "api/integrations";
import { isClientValidationError } from "utils/validation.utils";

interface Props {
  integration: { key: Integrations.Fcm; value: FcmConfig };
  updateIntegrationField: (key: string, value: Object) => void;
  readOnly?: boolean;
  errors: Error | null;
}

const Fcm: React.SFC<Props> = ({ integration, updateIntegrationField, readOnly, errors }) => {
  const integrationName = integration.key;
  return (
    <React.Fragment>
      <TextField
        label={t("integrations.fields.server-key")}
        value={integration.value["server-key"]}
        onChange={(value) => updateIntegrationField(integrationName, { "server-key": value })}
        readOnly={readOnly}
        errorMessage={
          isClientValidationError<FcmConfig>(errors) ? get(errors, ["errors", "value", "server-key", "0"]) : undefined
        }
      />
      <NumberField
        label={t("integrations.fields.ttl-web-in-hours")}
        value={integration.value["ttl-web-in-hours"]}
        onChange={(value: number) => updateIntegrationField(integrationName, { "ttl-web-in-hours": value || 0 })}
        min={0}
      />
      <NumberField
        label={t("integrations.fields.ttl-mobile-in-hours")}
        value={integration.value["ttl-mobile-in-hours"]}
        onChange={(value: number) => updateIntegrationField(integrationName, { "ttl-mobile-in-hours": value || 0 })}
        min={0}
      />
    </React.Fragment>
  );
};

export default Fcm;
